import { z } from 'zod';
import { countValidatorOptional } from '@/schemas/common/validators';

// Query schema for GET /api/chat/chats
export const GetChatsQuerySchema = z.object({
  page: countValidatorOptional.default(1),
});

export type GetChatsQuery = z.infer<typeof GetChatsQuerySchema>;

// User schema for response
const CompanionSchema = z.object({
  id: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  name: z.string(),
  email: z.string(),
  trustLevel: z.number(),
  photos: z.object({
    url: z.string(),
    thumbUrl: z.string(),
  }),
});

// Listing schema for response
const ListingSchema = z.object({
  id: z.string(),
  title: z.string(),
  price: z.number(),
  status: z.number(),
  hasPhoto: z.number(),
  photos: z.array(z.object({
    url: z.string(),
    thumbUrl: z.string(),
  })),
});

// Chat schema for response
// Using plain z.string() for dates to accept both ISO and MySQL formats
const ChatSchema = z.object({
  id: z.string(),
  listingId: z.string(),
  ownerId: z.number(),
  participantId: z.number(),
  companion: CompanionSchema.nullable(),
  listing: ListingSchema.nullable(),
  lastMessage: z.string(),
  lastMessageText: z.string(),
  lastSenderId: z.number().nullable(),
  unreadCount: z.number(),
  ownerNewMessages: z.number(),
  participantNewMessages: z.number(),
  updatedDate: z.string().nullable(),
  timestamp: z.string(),
});

// Success response schema
export const GetChatsSuccessResponseSchema = z.object({
  success: z.literal(true),
  chats: z.array(ChatSchema),
  page: z.number(),
  hasMore: z.boolean(),
});

export type GetChatsSuccessResponse = z.infer<typeof GetChatsSuccessResponseSchema>;

// Error response schema
export const GetChatsErrorResponseSchema = z.object({
  error: z.string(),
  message: z.string().optional(),
});

export type GetChatsErrorResponse = z.infer<typeof GetChatsErrorResponseSchema>;

// Union type for all responses
export const GetChatsResponseSchema = z.union([
  GetChatsSuccessResponseSchema,
  GetChatsErrorResponseSchema,
]);

export type GetChatsResponse = z.infer<typeof GetChatsResponseSchema>;
